import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-delete",
  "use": "icon-delete-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-delete\"><path d=\"M106.667 213.333h810.666V256H106.667zM640 128v42.667h42.667V128c0-23.573-19.094-42.667-42.539-42.667H383.872A42.496 42.496 0 00341.333 128v42.667H384V128h256zM213.333 896V256h-42.666v639.957c0 23.595 18.986 42.71 42.709 42.71h597.248c23.595 0 42.71-18.987 42.71-42.71V256h-42.667v640H213.333z\" /><path d=\"M320 341.333h42.667v384H320zm170.667 0h42.666v384h-42.666zm170.666 0H704v384h-42.667z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol